import { useEffect, useState } from "react";

export const Toast = ({ toast, onClose }) => {
  const { message, type } = toast;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onClose, 300); // Delay to match animation
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const typeStyles = {
    success: "bg-[#F6FFF9] border-[#48C1B5]",
    error: "bg-[#FFF6F6] border-[#CE584E]",
    warning: "bg-yellow-100 text-yellow-600 border-yellow-400",
    info: "bg-blue-100 text-blue-600 border-blue-400",
  };

  return (
    <div
      className={`flex items-center w-full max-w-sm p-4 border rounded-lg shadow-md transition-all duration-300 ease-in-out z-[99]
        ${typeStyles[type]} absolute top-6 left-1/2 transform -translate-x-1/2 
        ${visible ? "animate-slideDown opacity-100 translate-y-20" : "opacity-0 -translate-y-10"}`}
      role="alert"
    >
      <div className="flex-shrink-0">
        {type === "success" && (
          <div
            style={{
              background: "linear-gradient(180deg, #48CA93 0%, #48BACA 100%)",
            }}
            className="py-[5px] px-1 rounded-md"
          >
            <svg
              width="10"
              height="8"
              viewBox="0 0 10 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 4.5L3.5 6.5L8.5 1.5"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        )}
        {type === "error" && (
          <div
            style={{
              background: "linear-gradient(180deg, #E88B76 0%, #CA5048 100%)",
            }}
            className="py-1.5 px-1.5 rounded-md"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="8"
              viewBox="0 0 8 8"
              fill="none"
            >
              <path
                d="M6.99998 1.00002L1 7M0.999975 1L6.99995 6.99998"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
        )}
      </div>
      <div className="ml-3 text-[14px] font-mont font-[500]">{message}</div>
      <button
        onClick={() => setVisible(false)}
        className="ml-auto bg-transparent text-gray-500 hover:text-gray-900 rounded-lg p-1"
        aria-label="Close"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 4.00004L4 14M3.99996 4L13.9999 14"
            stroke="#979FA9"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </div>
  );
};
